<template>
    <div class="app-container">
      <el-row>
        <el-col :span="24">
          <!-- 面包屑导航区域-->
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
            <el-breadcrumb-item>Quality</el-breadcrumb-item>
            <el-breadcrumb-item>QA Report</el-breadcrumb-item>
          </el-breadcrumb>
        </el-col>
      </el-row>
      <el-card>
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="Project No:">
            <el-input v-model="formInline.projectName" placeholder="Project No" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">Search</el-button>
          </el-form-item>
          <br>
<!--          <el-form-item>-->
<!--            <el-button type="primary" @click="customerDialogOpen('add', '')">Add</el-button>-->
<!--          </el-form-item>-->
        </el-form>
        <el-table :data="qaReportList" border stripe style="width: 100%">
          <el-table-column
            show-overflow-tooltip
            prop="id"
            label="Id"         sortable
            width="120">
          </el-table-column>
          <el-table-column
            prop="projectName"
            label="project No"
            width="150">
          </el-table-column>
          <el-table-column
            prop="checkedBy"
            label="Checked By"
            width="150">
          </el-table-column>
          <el-table-column
            prop="sampleDisc"
            label="SampleDisc"
            show-overflow-tooltip
            width="100">
          </el-table-column>
          <el-table-column
            prop="comments"
            label="Comments"
            show-overflow-tooltip
            width="100">
          </el-table-column>
          <el-table-column
            prop="description"
            label="Description"
            show-overflow-tooltip
            width="100">
          </el-table-column>
          <el-table-column
            prop="material"
            label="Material"
            show-overflow-tooltip
            width="100">
          </el-table-column>
          <el-table-column
            prop="supplier"
            label="Supplier"
            width="100">
          </el-table-column>
          <el-table-column
            prop="brand"
            label="Brand"
            width="100">
          </el-table-column>
          <el-table-column
            prop="bp"
            label="BP"
            width="100">
          </el-table-column>
          <el-table-column
            prop="proType"
            label="Type"
            width="150">
          </el-table-column>
          <el-table-column fixed="right"
                           prop="conclusion"
                           label="Conclusion"
                           width="100">
            <template slot-scope="scope">
          <span v-if="scope.row.conclusion === '0'">
            <el-tag type="success" effect="dark">Accept</el-tag>
          </span>
              <span v-if="scope.row.conclusion === '1'">
            <el-tag type="danger" effect="dark">Reject</el-tag>
          </span>
              <span v-if="scope.row.conclusion === '2'">
            <el-tag type="warning" effect="dark">FYI</el-tag>
          </span>
              <span v-if="scope.row.conclusion === '3'">
            <el-tag type="info" effect="dark">Pending</el-tag>
          </span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="Operation" width="350">
            <template slot-scope="index">
              <el-button type="info" plain size="mini" @click="goDetail(index)">View</el-button>
              <el-button type="info" plain size="mini" @click="customerDialogOpen(index)">Edit</el-button>
              <el-button type="info" plain size="mini" @click="goQATest(index)">QA Test Data</el-button>
              <el-button type="info" plain size="mini" @click="goQARequset(index)">Request</el-button>
            </template>
          </el-table-column>
        </el-table>
        <br>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage4"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total=total>
        </el-pagination>
      </el-card>
      <el-dialog title="Edit QA Report" :visible.sync="open" width="60%">
        <el-form ref="form" :model="form" label-width="180px">
          <h3>Results:</h3>
          <el-form-item label="Conclusion" prop="conclusion">
            <!--          <el-input v-model="form.appeanance" placeholder="Appeanance" />-->
            <el-radio v-model="form.conclusion" label="0">Accept</el-radio>
            <el-radio v-model="form.conclusion" label="1">Reject</el-radio>
            <el-radio v-model="form.conclusion" label="3">Pending</el-radio>
          </el-form-item>
          <h3>Dev:</h3>
          <el-form-item label="Dev Comments" prop="devComments">
            <el-input v-model="form.devComments" type="text" maxlength="250" show-word-limit/>
          </el-form-item>
          <el-form-item label="Dev Improve" prop="improve">
            <el-input v-model="form.improve" type="text" maxlength="250" show-word-limit/>
          </el-form-item>
          <h3>Base Info:</h3>
          <el-form-item label="Id" prop="id">
            <el-input disabled v-model="form.id"/>
          </el-form-item>
          <el-form-item label="Project" prop="projectName">
            <el-input disabled v-model="form.projectName"/>
          </el-form-item>
          <el-form-item label="Sample Disc" prop="sampleDisc">
            <el-input disabled v-model="form.sampleDisc"/>
          </el-form-item>
          <el-form-item label="Description" prop="description">
            <el-input disabled v-model="form.description"/>
          </el-form-item>
          <el-form-item label="Comments" prop="comments">
            <el-input disabled v-model="form.comments"/>
          </el-form-item>
          <el-form-item label="Quantity" prop="quantity">
            <el-input disabled v-model="form.quantity"/>
          </el-form-item>
          <el-form-item label="Report Date" prop="reportDate">
            <el-date-picker clearable
                            v-model="form.reportDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="Report Date">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="Checked By" prop="checkedBy">
            <!--          <el-input v-model="form.askedBy" placeholder="Asked By" />-->
            <el-select v-model="form.checkedBy" placeholder="select">
              <el-option
                v-for="item in checkedBy"
                :key="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Type Of Product" prop="proType">
            <!--          <el-input v-model="form.askedBy" placeholder="Asked By" />-->
            <el-select disabled v-model="form.proType" placeholder="select">
              <el-option
                v-for="item in cgList"
                :key="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Material" prop="material">
            <el-input disabled type="text" maxlength="250" show-word-limit v-model="form.material"/>
          </el-form-item>
          <el-form-item label="Remark" prop="remark">
            <el-input v-model="form.remark"/>
          </el-form-item>
          <el-form-item label="Picture:">
<!--            <el-upload-->
<!--              class="avatar-uploader"-->
<!--              ref="upload"-->
<!--              :limit="1"-->
<!--              :action="uploadImgUrl"-->
<!--              :before-upload="beforeAvatarUpload"-->
<!--              :on-success="handleAvatarSuccess"-->
<!--            :on-change="handleChange"-->
            <!--              :show-file-list ="false"-->
<!--              :multiple="false"-->
<!--              accept=".jpg, .png"-->
<!--            >-->
            <el-upload
              class="avatar-uploader"
              ref="upload"
              drag
              multiple
              :limit="10"
              :action="uploadImgUrl"
              :before-upload="beforeAvatarUpload"
              :on-success="handleAvatarSuccess"
              :on-remove="handleRemove"
              :show-file-list ="true"
              :file-list="form.fileList"
              list-type="picture"
              accept=".jpg, .png"
            >
              <!--              <i class="el-icon-plus avatar-uploader-icon"></i>-->
<!--              <img v-if="form.picUrl" :src="form.picUrl" class="avatar">-->
<!--              <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div class="el-upload__tip" slot="tip">Must be JPG/PNG and less than 2MB</div>
            </el-upload>
          </el-form-item>
          <br><br>
          <h3>General appearance of the Samples:</h3><br>
          <el-form-item label="Coherent color range of the sample submitted|颜色一致性" prop="color">
            <!--          <el-input v-model="form.appeanance" placeholder="Appeanance" />-->
            <el-radio v-model="form.color" label="0">OK</el-radio>
            <el-radio v-model="form.color" label="1">NG</el-radio>
          </el-form-item>
          <el-form-item label="Remark" prop="colorRemark">
            <el-input type="text" maxlength="250" show-word-limit v-model="form.colorRemark" placeholder="Remark" />
          </el-form-item>
          <br>
          <el-form-item label="Scratch on the surface|表面擦伤" prop="scratch">
            <!--          <el-input v-model="form.appeanance" placeholder="Appeanance" />-->
            <el-radio v-model="form.scratch" label="0">OK</el-radio>
            <el-radio v-model="form.scratch" label="1">NG</el-radio>
          </el-form-item>
          <el-form-item label="Remark" prop="scratchRemark">
            <el-input type="text" maxlength="250" show-word-limit v-model="form.scratchRemark" placeholder="Remark" />
          </el-form-item>
          <br>
          <el-form-item label="Dot on the metalization or electroplating|表面杂点" prop="metalization">
            <!--          <el-input v-model="form.appeanance" placeholder="Appeanance" />-->
            <el-radio v-model="form.metalization" label="0">OK</el-radio>
            <el-radio v-model="form.metalization" label="1">NG</el-radio>
          </el-form-item>
          <el-form-item label="Remark" prop="metalizationRemark">
            <el-input type="text" maxlength="250" show-word-limit v-model="form.metalizationRemark" placeholder="Remark" />
          </el-form-item>
          <br>
          <el-form-item label="General cleanliness of the samples submitted|表面清洁度" prop="cleanliness">
            <!--          <el-input v-model="form.appeanance" placeholder="Appeanance" />-->
            <el-radio v-model="form.cleanliness" label="0">OK</el-radio>
            <el-radio v-model="form.cleanliness" label="1">NG</el-radio>
          </el-form-item>
          <el-form-item label="Remark" prop="cleanlinessRemark">
            <el-input type="text" maxlength="250" show-word-limit v-model="form.cleanlinessRemark" placeholder="Remark" />
          </el-form-item>
          <br>
          <el-form-item label="Other appearance defects|其他外观缺陷" prop="other">
            <!--          <el-input v-model="form.appeanance" placeholder="Appeanance" />-->
            <el-radio v-model="form.other" label="0">OK</el-radio>
            <el-radio v-model="form.other" label="1">NG</el-radio>
          </el-form-item>
          <el-form-item label="Remark" prop="otherRemark">
            <el-input type="text" maxlength="250" show-word-limit v-model="form.otherRemark" placeholder="Remark" />
          </el-form-item>
          <br>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="submitForm()">Save</el-button>
<!--          <el-button @click="cancel">Cancel</el-button>-->
        </div>
      </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'QAReport',
  data () {
    return {
      total: 0,
      uploadImgUrl: axios.defaults.baseURL + '/file/upload/img/',
      checkedBy: ['David Huang', 'Jack Liu', 'Yuhang Dong', 'Tom Wang', 'Jean Chen', 'Bruce Liu', 'Shuhua Cai', 'Martha Wang', 'Linda Wang', 'Iris Yang'],
      cgList: [],
      form: {},
      open: false,
      qaReportList: [],
      formInline: {
        projectName: '',
        pageNo: 1,
        pageSize: 100
      }
    }
  },
  created () {
    this.formInline = this.$route.query
    this.formInline.pageNo = 1
    this.formInline.pageSize = 100
    this.getList()
    this.getCgList()
  },
  methods: {
    async handleSizeChange (val) {
      this.formInline.pageSize = val
      const { data: res } = await this.$http.get('/qaReport/list', { params: this.formInline })
      this.qaProjectList = res.result.records
      this.total = res.result.total
    },
    async handleCurrentChange (val) {
      this.formInline.pageNo = val
      const { data: res } = await this.$http.get('/qaReport/list', { params: this.formInline })
      this.qaProjectList = res.result.records
      this.total = res.result.total
    },
    async submitForm () {
      // if (!this.form.projectId) {
      //   this.$message({
      //     message: 'Please enter or select projectId',
      //     type: 'warning'
      //   })
      //   return
      // }
      await this.$http.post('/qaReport/add', this.form)
        .then((res) => {
          if (res.data.success) {
            this.$message({
              message: 'Added or updated successfully',
              type: 'success'
            })
            this.open = false
            this.getList()
          }
        })
    },
    handleChange (file, fileList) {
      const list = []
      for (let i = 0; i < fileList.length; i++) {
        list.push(fileList[i].response)
      }
      this.form.imgs = list.toString()
      console.log(this.form)
    },
    handleRemove (file, fileList) {
      const list = []
      for (let i = 0; i < fileList.length; i++) {
        list.push(fileList[i].response)
      }
      this.form.imgs = list.toString()
      console.log(this.form)
    },
    handleAvatarSuccess (res, file, fileList) {
      console.log(fileList)
      // this.$refs.upload.clearFiles()
      // this.form.picUrl = URL.createObjectURL(file.raw)
      // this.form.picUrl = res
      const list = []
      for (let i = 0; i < fileList.length; i++) {
        list.push(fileList[i].response)
      }
      this.form.imgs = list.toString()
      console.log(this.form)
    },
    beforeAvatarUpload (file) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!(file.type === 'image/jpeg' || file.type === 'image/png')) {
        this.$message.error('The format must be JPG/PNG!')
        return false
      }
      if (!isLt2M) {
        this.$message.error('Must be less than 2MB!')
        return false
      }
    },
    customerDialogOpen (index) {
      console.log(index.row)
      this.open = true
      this.form = index.row
      if (this.form.imgs) {
        const list = []
        for (let i = 0; i < this.form.imgs.split(',').length; i++) {
          const map = { name: i, response: this.form.imgs.split(',')[i], url: this.form.imgs.split(',')[i] }
          list.push(map)
        }
        this.form.fileList = list
      }
    },
    goQATest (index) {
      this.$router.push(`/QATest?reportId=${index.row.id}`)
    },
    goQARequset (index) {
      // console.log(index.row)
      this.$router.push(`/qaTestRequest?sequenceNo=${index.row.projectName}&bp=${index.row.bp}&brand=${index.row.brand}&description=${index.row.description}`)
    },
    goDetail (index) {
      // this.$router.push(`/qaReportDetail?qaReportId=${index.row.id}`)
      // this.$router.push({ path: '/logistics-track', query: { orderNo: row.row.orderNo }})

      // const routeData = this.$router.resolve({ path: '/logistics-track', query: { orderNo: row.row.orderNo }})
      // window.open(routeData.href, '_blank')
      // const routeData = this.$router.resolve(`/qaReportDetail?qaReportId=${index.row.id}`)
      // window.open(routeData.href, '_blank')
      this.$router.push(`/qaReportDetail?qaReportId=${index.row.id}`)
    },
    onSubmit () {
      console.log('submit!')
      this.getList()
    },
    async getList () {
      const { data: res } = await this.$http.get('/qaReport/list', { params: this.formInline })
      this.qaReportList = res.result.records
      this.total = res.result.total
    },
    async getCgList () {
      const { data: res } = await this.$http.get('/qualityCategories/getQualityCategoriesList', { params: { page: 1, size: 100, type: 'qa', level: 1 } })
      const list = []
      for (let i = 0; i < res.records.length; i++) {
        list.push(res.records[i].name)
      }
      this.cgList = list
    }
  }
}
</script>

<style scoped>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
